/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview PaymentModal ErrorStep step UI.
 * @module modals/PaymentModal/steps/PaymentModalErrorStep
 */

import { ReactComponent as PaymentErrorIcon } from "../../../assets/icons/PaymentModal/PaymentErrorIcon.svg";

const PaymentModalErrorStep = ({ styles, t, event, getEventCost }) => (
            <div className={styles.stepContent}>
              <div className={styles.cardPaymentTitleContainer}>
                <div className={styles.cardPaymentTitle}>
                  {t("components.paymentModal.cardSection4Title")}
                </div>
                <p className={styles.cardPaymentSubtitle}>
                  {t("components.paymentModal.cardSection4Description")}
                </p>
              </div>
              <div className={styles.cardPaymentErrorContent}>
                <div className={styles.cardPaymentErrorIconContainer}>
                  <PaymentErrorIcon className={styles.cardPaymentErrorIcon} />
                </div>
                {/* Payment Error Details Section */}
                <div className={styles.cardPaymentErrorSection}>
                  <div className={styles.cardPaymentErrorRow}>
                    <span className={styles.cardPaymentErrorLabel}>
                      {t("components.paymentModal.cardSection4Label1")}
                    </span>
                  </div>
                  <div className={styles.cardPaymentErrorRowCentered}>
                    <span className={styles.cardPaymentErrorLabel2}>
                      {t("components.paymentModal.cardSection4Label2")}
                    </span>
                  </div>
                  <div className={styles.cardPaymentErrorRowCentered}>
                    <span className={styles.cardPaymentErrorValue}>
                      {event.nombre}
                    </span>
                  </div>
                  <div className={styles.cardPaymentDivider}></div>
                  <div className={styles.cardPaymentDetailRow}>
                    <span className={styles.cardPaymentErrorLabel}>
                      {t("components.paymentModal.cardSection4Label3")}
                    </span>
                    <span className={styles.cardPaymentErrorValue}>
                      ${getEventCost()} MXN
                    </span>
                  </div>
                </div>
              </div>
            </div>
);

export default PaymentModalErrorStep;
